import store from "@/store";

export default [
  {
    name: "login",
    meta: {
      title: "Login",
    },
    path: "/login",
    component: () => import("@/views/pages/auth/login.vue"),
    beforeEnter(to, from, next) {
      if (store.getters.authenticated) {
        next({ name: "home" });
      } else {
        next();
      }
    },
  },
  {
    name: "forgot-password",
    meta: {
      title: "Forgot Password",
    },
    path: "/forgot-password",
    component: () => import("@/views/pages/auth/forgot.vue"),
    beforeEnter(to, from, next) {
      if (store.getters.authenticated) {
        next({ name: "home" });
      } else {
        next();
      }
    },
  },
  {
    name: "reset-password",
    meta: {
      title: "Reset Password",
    },
    path: "/reset-password/:slug",
    component: () => import("@/views/pages/auth/reset-password.vue"),
    beforeEnter(to, from, next) {
      if (store.getters.authenticated) {
        next({ name: "cards" });
      } else {
        next();
      }
    },
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("@/views/pages/auth/logout.vue"),
    beforeEnter(to, from, next) {
      if (store.getters.authenticated) {
        next();
      } else {
        next({ name: "login" });
      }
    },
  },
];
